import Swal from 'sweetalert2';
import { Injectable } from '@angular/core';
import { ExtendedRow } from 'src/app/models/libraryModel/extendedRow.model';

@Injectable({
  providedIn: 'root',
})
export class SweetAlertService {

private buttonStyles = {
    confirmButton: 'btn btn-primary',
    cancelButton: 'btn btn-secondary',
    denyButton: 'btn btn-danger',
};

  confirmSaveChanges(changes: string, message = 'Do you want to save the changes?'): Promise<any> {
    return Swal.fire({
      title: message,
      html: changes,
      showCancelButton: true,
      confirmButtonText: 'Save',
      denyButtonText: `Don't save`,
      customClass: this.buttonStyles,
      
    });
  }

  confirmDiscardChanges(message = 'You have unsaved changes. Save them before switching, or they will be lost.'): Promise<any> {
    return Swal.fire({
      title: 'Unsaved Changes',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Discard changes',
      cancelButtonText: 'Cancel',
      customClass: this.buttonStyles,
    });
  }

  showSuccessMessage(message: string): void {
    Swal.fire({
      text: message,
      icon: 'success',
      customClass: this.buttonStyles,
    });
  }

  showInfoMessage(message: string): void {
    Swal.fire({
      text: message,
      icon: 'info',
      customClass: this.buttonStyles,
    });
  }

  showErrorMessage(message: string): void {
    Swal.fire({
      title: 'Error',
      text: message,
      icon: 'error',
      customClass: this.buttonStyles,
    });
  }
}